export default __webpack_public_path__ + "static/media/check-on.78af74a5.svg";